import { defineMessages } from 'react-intl';
import type { SocialImpactEnum } from '@foundershub/api-client';

export const socialImpactLabels = defineMessages<SocialImpactEnum>({
  'no-poverty': {
    defaultMessage: 'No Poverty',
    description: 'UN sustainability/social impact goal label',
  },
  'zero-hunger': {
    defaultMessage: 'Zero Hunger',
    description: 'UN sustainability/social impact goal label',
  },
  'good-health-well-being': {
    defaultMessage: 'Good Health & Well-Being',
    description: 'UN sustainability/social impact goal label',
  },
  'quality-education': {
    defaultMessage: 'Quality Education',
    description: 'UN sustainability/social impact goal label',
  },
  'gender-equality': {
    defaultMessage: 'Gender Equality',
    description: 'UN sustainability/social impact goal label',
  },
  'clean-water-sanitation': {
    defaultMessage: 'Clean Water & Sanitation',
    description: 'UN sustainability/social impact goal label',
  },
  'affordable-clean-energy': {
    defaultMessage: 'Affordable & Clean Energy',
    description: 'UN sustainability/social impact goal label',
  },
  'decent-work-economic-growth': {
    defaultMessage: 'Decent Work & Economic Growth',
    description: 'UN sustainability/social impact goal label',
  },
  'industry-innovation-infrastructure': {
    defaultMessage: 'Industry, Innovation & Infrastructure',
    description: 'UN sustainability/social impact goal label',
  },
  'reduced-inequalities': {
    defaultMessage: 'Reduced Inequalities',
    description: 'UN sustainability/social impact goal label',
  },
  'sustainable-cities-communities': {
    defaultMessage: 'Sustainable Cities & Communities',
    description: 'UN sustainability/social impact goal label',
  },
  'responsible-consumption-production': {
    defaultMessage: 'Responsible Consumption & Production',
    description: 'UN sustainability/social impact goal label',
  },
  'climate-action': {
    defaultMessage: 'Climate Action',
    description: 'UN sustainability/social impact goal label',
  },
  'life-below-water': {
    defaultMessage: 'Life Below Water',
    description: 'UN sustainability/social impact goal label',
  },
  'life-on-land': {
    defaultMessage: 'Life On Land',
    description: 'UN sustainability/social impact goal label',
  },
  'peace-justice-strong-institutions': {
    defaultMessage: 'Peace, Justice & Strong Institutions',
    description: 'UN sustainability/social impact goal label',
  },
  'partnerships-for-the-goals': {
    defaultMessage: 'Partnerships for the Goals',
    description: 'UN sustainability/social impact goal label',
  },
});
